const FORMSTACK = (window as any).FORMSTACK || {};
FORMSTACK.COPILOT = FORMSTACK.COPILOT || {};
FORMSTACK.COPILOT.REF = process.env.COPILOT_REF || '0.0.0';
FORMSTACK.COPILOT.BUILD_ENV = process.env.COPILOT_BUILD_ENV || 'production';
(window as any).FORMSTACK = FORMSTACK;
